import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';
import { BeneficiaryDetailsComponent } from './beneficiary-details/beneficiary-details.component';
import { ComplementComponent } from './beneficiary-details/complement/complement.component';
import { DocumentComponent } from './beneficiary-details/documents/document.component';
import { EmploymentComponent } from './beneficiary-details/employment/employment.component';
import { PersonalDataComponent } from './beneficiary-details/personal-data/personal-data.component';
import { AssessmentComponent } from './beneficiary-folder/assessment/assessment.component';
import { BeneficiaryFolderComponent } from './beneficiary-folder/beneficiary-folder.component';
import { ContractComponent } from './beneficiary-folder/contract/contract.component';
import { FSEComponent } from './beneficiary-folder/fse/fse.component';
import { InterviewComponent } from './beneficiary-folder/interview/interview.component';
import { StageComponent } from './beneficiary-folder/stages/stage.component';
import { BeneficiaryListComponent } from './beneficiary-list/beneficiary-list.component';
import { BeneficiaryPerimeterGuard } from './beneficiary-perimeter.guard';
import { BeneficiaryGuard } from './beneficiary.guard';
import { RsjDetailsComponent } from './rsj/rsj-details.component';
import { RsjInstructionComponent } from './rsj/rsj-instruction/rsj-instruction.component';
import { RsjPaymentComponent } from './rsj/rsj-payment/rsj-payment.component';
import { RsjPersonalDataComponent } from './rsj/rsj-personal-data/rsj-personal-data.component';

const routes: Routes = [
  {
    path: '',
    component: BeneficiaryListComponent,
    canActivate: [AuthGuard],
    data: { groups: ['ADMIN', 'STRUCTURE', 'RECEPTION', 'TERRITORY', 'DIRECTION', 'DIRECTION+'] },
  },
  {
    path: ':id/folder',
    component: BeneficiaryFolderComponent,
    canActivate: [AuthGuard, BeneficiaryGuard],
    canActivateChild: [BeneficiaryPerimeterGuard],
    data: { groups: ['ADMIN', 'STRUCTURE', 'RECEPTION', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE'] },
    children: [
      { path: '', redirectTo: 'interviews', pathMatch: 'full' },
      { path: 'interviews', component: InterviewComponent },
      { path: 'contracts', component: ContractComponent },
      { path: 'stages', component: StageComponent },
      { path: 'fse', component: FSEComponent },
      { path: 'assessment', component: AssessmentComponent },
    ],
  },
  {
    path: ':id/details',
    component: BeneficiaryDetailsComponent,
    canActivate: [AuthGuard, BeneficiaryGuard],
    canActivateChild: [BeneficiaryPerimeterGuard],
    data: { groups: ['ADMIN', 'STRUCTURE', 'RECEPTION', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE'] },
    children: [
      { path: '', redirectTo: 'personaldata', pathMatch: 'full' },
      { path: 'personaldata', component: PersonalDataComponent },
      { path: 'complement', component: ComplementComponent },
      { path: 'employment', component: EmploymentComponent },
      { path: 'documents', component: DocumentComponent },
    ],
  },
  {
    path: ':id/rsj',
    component: RsjDetailsComponent,
    canActivate: [AuthGuard, BeneficiaryGuard],
    canActivateChild: [BeneficiaryPerimeterGuard],
    data: { groups: ['ADMIN', 'STRUCTURE', 'DIRECTION+'] },
    children: [
      { path: '', redirectTo: 'rsj-personaldata', pathMatch: 'full' },
      { path: 'rsj-personaldata', component: RsjPersonalDataComponent },
      { path: 'rsj-payment', component: RsjPaymentComponent },
      { path: 'rsj-instruction', component: RsjInstructionComponent },
      { path: 'rsj-document', component: DocumentComponent },
    ],
  },
  {
    path: 'new',
    component: BeneficiaryDetailsComponent,
    canActivate: [AuthGuard, BeneficiaryGuard],
    canActivateChild: [BeneficiaryPerimeterGuard],
    data: { groups: ['ADMIN', 'STRUCTURE', 'RECEPTION', 'TERRITORY'] },
    children: [
      { path: '', redirectTo: 'personaldata', pathMatch: 'full' },
      { path: 'personaldata', component: PersonalDataComponent },
      { path: '**', redirectTo: 'personaldata', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BeneficiariesRoutingModule {}
